const serializeEditorHtml = (htmlStr: string) => {
  htmlStr = htmlStr.replace(
    /(?:editor-highlight-number|numeric-citation)/g,
    "span"
  );
  const parser = new DOMParser();
  const doc = parser.parseFromString(htmlStr, "text/html");
  return getTextFromNodes(doc.body.childNodes);
};

const newLineTags = ["H1", "H2", "H3", "H4", "H5", "H6", "LI", "OL", "UL"];

const getTextFromNodes = (nodes: NodeListOf<ChildNode>) => {
  let text = "";

  nodes.forEach((node) => {
    if (node.nodeType === Node.TEXT_NODE) {
      text += node.textContent || "";
    } else if (node.nodeType === Node.ELEMENT_NODE) {
      text += getTextFromNodes(node.childNodes);
      if (newLineTags.includes(node.nodeName)) {
        text += "\n";
      }
    }
  });

  return text;
};

export default serializeEditorHtml;
